export const AGENCY_FETCH = 'AGENCY_FETCH'
export const AGENCY_CREATE = 'AGENCY_CREATE'
export const AGENCY_UPDATE = 'AGENCY_UPDATE'
